import { Component, OnInit } from '@angular/core';
import { Injectable, Output, EventEmitter } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { parseStringPromise } from 'xml2js';
import { HttpClient } from '@angular/common/http';
import { FooterService } from '../../core/services/footer.services';
import { environment } from '../../../environments/environment';
import { ShoppingService } from '../../core/services/shopping.service';
import { HelperService } from '../../core/services/helper.service';
import { appVariables } from '../../core/constants/Common.constant';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private http: HttpClient,
    private footerService: FooterService,
    private shoppingService: ShoppingService,
    private helperservice: HelperService,
    private activatedRoute: ActivatedRoute) {
  }

  resourceStudent: string = `${environment.FADBaseUrl}resourcecenter/student`;
  resourceInstructor: string = `${environment.FADBaseUrl}resourcecenter/instructor`;
  footerListData: any = [];
  public copyRightYear: number=new Date().getFullYear();
  IsLTICall: boolean;

  ngOnInit() {
    this.IsLTICall = false;
    this.shoppingService.observeIsLTI.subscribe(IsLTICall => {
      this.IsLTICall = IsLTICall;
    });
    if (this.IsLTICall != undefined && this.IsLTICall == false) {
      this.updateDavisAdvatangeTokenUrl();
      this.footerService.GetFooterDetails().subscribe(
        (response: any) => {
          this.parseXML(response);
        },
        (error) => {
          console.log(error);
        });
    }
  }

  updateDavisAdvatangeTokenUrl() {
    this.shoppingService.observApplicationList.subscribe(res => {
      if (res.length > 0 && this.footerListData.length > 0) {
        let displayText = res.find(x => x.AppID == 11).AppName;
        let token = (this.helperservice.getFromLocalStorage(appVariables.accessTokenLocalStorage)) ? this.helperservice.getFromLocalStorage(appVariables.accessTokenLocalStorage) : ``;
        this.footerListData.map((parentItem) => {
          parentItem.Link.filter((childItem) => (childItem.DisplayText == displayText)
            ? childItem.URL = (token) ? `${environment.davisadvantageLoginUrl}?token=${token}` : environment.AdvantageHomeurl
            : "")
        });
      }
    });
  }


  parseXML(data) {
    let res = JSON.parse(data);
    let footerData: any;
    let xml2js = require('xml2js');

    var parser = new xml2js.Parser();
    res.Data = res.Data.replace('360Â°', '360°')
    parser.parseString(res.Data, function (err, result) {
      footerData = result.Columns.Column;
    });
    if (footerData) {
      this.footerListData = footerData;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/footer/footer.component.ts